/*
 * @Descripttion: 服务支持路由
 * @version: V1.0
 * @Author: yuanxing(01407381)
 * @Date: 2022-01-19 10:43:05
 */

// 服务支持---查询支持---分类
export const QuerySupportList = [
  // {
  //   name: 'freight',
  //   cname: '查运费',
  //   path: '/support/querySupport/freight',
  //   il8nName: 'serviceSupport.querySupport.freight',
  // },
  // {
  //   name: 'comprehensiveQuery',
  //   cname: '综合查询',
  //   path: '/support/querySupport/comprehensive_query',
  //   il8nName: 'serviceSupport.querySupport.comprehensiveQuery',
  //   hidden: { mb: true }, // 移动端隐藏，仅PC端展示
  // },
  // {
  //   name: 'waybill',
  //   cname: '查运单',
  //   path: '/support/querySupport/waybill',
  //   il8nName: 'serviceSupport.querySupport.waybill',
  // },
  // {
  //   id: 'scope',
  //   name: 'service_scope',
  //   cname: '查收送范围',
  //   trackFn: QueryServicecoverageClick,
  //   path: allUrls.sfExpressRangeUrl,
  //   pathMobile: allUrls.sfExpressRangeMobileUrl,
  //   il8nName: 'serviceSupport.querySupport.service_scope',
  // },
  // {
  //   name: 'freight_aging',
  //   cname: '查运费时效',
  //   path: '/support/querySupport/freight_aging',
  //   il8nName: 'serviceSupport.querySupport.freight_aging',
  // },
  // {
  //   name: 'dept',
  //   cname: '查服务网点',
  //   path: '/support/querySupport/dept',
  //   il8nName: 'serviceSupport.querySupport.service_dept',
  // },
  // {
  //   name: 'posting_std',
  //   cname: '查收寄标准',
  //   path: '/support/querySupport/receiving_standard',
  //   il8nName: 'navs.posting_std',
  // },
  // {
  //   name: 'exce_rate',
  //   cname: '查汇率',
  //   path: '/support/querySupport/exce_rate',
  //   il8nName: 'serviceSupport.querySupport.exce_rate',
  // },
  // {
  //   name: 'holiday',
  //   cname: '查节假日服务计划',
  //   path: '/support/querySupport/holiday',
  //   il8nName: 'serviceSupport.querySupport.holidays.navTitle',
  // },
  // {
  //   name: 'fee_rate',
  //   cname: '查价格费率',
  //   path: '/support/querySupport/fee_rate',
  //   il8nName: 'serviceSupport.querySupport.fee_rate',
  // },
  // {
  //   name: 'auth_reseller',
  //   cname: '授权合作伙伴服务点',
  //   path: '/support/querySupport/auth_reseller',
  //   il8nName: 'navs.authReseller',
  // },
  // {
  //   name: 'download_file',
  //   cname: '文件自助下载',
  //   path: '/support/querySupport/download_file',
  //   il8nName: 'navs.downloadFile',
  // },
  // {
  //   name: 'invoice_request',
  //   cname: '发票申请',
  //   path: '/support/querySupport/invoiceRequest',
  //   hidden: { mb: false },
  //   il8nName: 'serviceSupport.invoice.invoiceRequest',
  // },
]

// 服务支持---清关服务---分类
export const customsClearanceList = [
  {
    name: 'uploadPhotos',
    cname: '上传清关图片',
    path: '/support/customsClearance/uploadPhotos',
    il8nName: 'navs.uploadPhotos',
    customLink: ({ site, lang }, path, params = { query: {}, hash: '' }) => {
      return `/ocss-site/${site}/${lang}/support/customsClearance/uploadPhotos`
    }, // 是否有自定义跳转
  },
  {
    name: 'DeclarationQuery',
    cname: '清关文件查询',
    path: '/support/customsClearance/certificateQuery',
    il8nName: 'navs.declarationQuery',
  },
  {
    name: 'DeclarationNotice',
    cname: '清关注意事项',
    path: '/support/customsClearance/declarationNotice',
    il8nName: 'navs.declarationNotice',
  },
  {
    name: 'posting_std',
    cname: '查收寄标准',
    path: '/support/querySupport/receiving_standard',
    il8nName: 'navs.posting_std',
  },
]

export default {
  path: '',
  cname: '服务支持',
  name: 'support',
  il8nName: 'modules.newJp.support',
  children: [
    {
      name: 'downloadTextFile',
      cname: '文件自助下载',
      path: '/support/querySupport/downloadTextFile',
      il8nName: 'navs.downloadFile',
    },
    {
      path: '/support/customsClearance/uploadPhotos',
      cname: '清关服务',
      name: 'customsClearance',
      il8nName: 'navs.clearanceService',
      children: customsClearanceList,
          customLink: ({ site, lang }, path, params = { query: {}, hash: '' }) => {
      return `/ocss-site/${site}/${lang}/support/customsClearance/uploadPhotos`
    }, // 是否有自定义跳转
    },
    {
      name: 'exce_rate',
      cname: '查汇率',
      path: '/support/querySupport/exce_rate',
      il8nName: 'serviceSupport.querySupport.exce_rate',
    },
    {
      name: 'freight_aging',
      cname: '查运费时效',
      path: '/support/querySupport/freight_aging',
      il8nName: 'serviceSupport.querySupport.freight_aging',
    },
    {
      path: '/support/querySupport/fuelSurcharge',
      cname: '燃油附加费',
      name: 'fuelSurcharge',
      hidden: { menu: false },
      il8nName: 'navs.fuelSurcharge',
    },
    {
      path: '/support/faq',
      cname: '常见问题解答',
      name: 'commst_problem',
      il8nName: 'navs.FAQ',
    },
    // {
    //   path: '/support/suggestion',
    //   cname: '功能反馈',
    //   name: 'suggestion',
    //   il8nName: 'navs.funcSuggestion',
    // },
    // {
    //   path: '',
    //   cname: '查询支持',
    //   name: 'querySupport',
    //   il8nName: 'navs.querySupport',
    //   children: QuerySupportList,
    // },
    // {
    //   path: '/support/termsOfUse',
    //   cname: '使用条款',
    //   name: 'navs.termsOfUse',
    //   il8nName: 'navs.termsOfUse',
    // },
    // {
    //   path: '/support/privacyPolicy',
    //   cname: '隐私政策',
    //   name: 'serviceSupport.privacyPolicy',
    //   il8nName: 'navs.privacyPolicy',
    // },
    // {
    //   path: '/support/guide',
    //   cname: '新手指南',
    //   name: 'commst_guide',
    //   il8nName: 'navs.guide',
    // },
    // {
    //   path: '',
    //   cname: '下载中心',
    //   name: 'download_center',
    //   il8nName: '',
    // },
  ],
}
